var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-button',{attrs:{"color":_vm.color,"disabled":_vm.disabled,"size":_vm.size,"icon":_vm.icon},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.title || '确定')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }